(()=>{'use strict';
class LabFilm extends HTMLElement{
 connectedCallback(){
  if(this.abort)return;
  this.video=this.querySelector('.lab-hero-video');
  if(!this.video)return;
  this.abort=new AbortController();
  const signal=this.abort.signal;
  this.mobile=matchMedia('(max-width:600px)');
  this.reduced=matchMedia('(prefers-reduced-motion:reduce)');
  this.inView=false;
  this.restartOnEnter=false;
  this.canPlay=()=>this.isConnected&&this.inView&&!document.hidden&&this.dataset.autoplay==='true'&&!this.reduced.matches&&!navigator.connection?.saveData;
  this.sync=()=>{
   if(!this.canPlay()){this.video.pause();return}
   const restart=this.restartOnEnter;
   if(restart){this.video.currentTime=0;this.restartOnEnter=false}
   if((restart||!this.video.ended)&&this.video.paused)this.video.play().catch(()=>{});
  };
  this.choose=()=>{
   const next=this.mobile.matches?this.dataset.mobile:this.dataset.desktop;
   if(!next)return;
   if(this.video.getAttribute('src')!==next){
    this.video.classList.remove('is-ready');
    this.video.src=next;
    this.video.loop=this.dataset.loop==='true';
    this.video.load();
   }
   this.sync();
  };
  this.video.addEventListener('playing',()=>{
   this.video.classList.add('is-ready');
   if(!this.canPlay())this.video.pause();
  },{signal});
  this.video.addEventListener('error',()=>this.video.classList.remove('is-ready'),{signal});
  document.addEventListener('visibilitychange',this.sync,{signal});
  this.mobile.addEventListener('change',this.choose,{signal});
  this.reduced.addEventListener('change',this.sync,{signal});
  navigator.connection?.addEventListener('change',this.sync,{signal});
  this.observer=new IntersectionObserver(entries=>{
   const entry=entries[entries.length-1];
   const nextInView=entry.isIntersecting&&entry.intersectionRatio>0;
   if(this.inView&&!nextInView)this.restartOnEnter=true;
   this.inView=nextInView;
   this.sync();
  },{threshold:0});
  this.choose();
  this.observer.observe(this.video);
 }
 disconnectedCallback(){
  this.observer?.disconnect();
  this.abort?.abort();
  this.video?.pause();
  this.abort=null;
 }
}
if(!customElements.get('lab-film'))customElements.define('lab-film',LabFilm);
document.addEventListener('click',event=>{
 const trigger=event.target.closest('[data-cookie-preferences]');
 if(!trigger)return;
 const status=document.querySelector('[data-cookie-message]');
 if(window.privacyBanner?.showPreferences){window.privacyBanner.showPreferences().catch(()=>{if(status)status.textContent=trigger.dataset.error});return}
 if(status)status.textContent=trigger.dataset.error;
});
})();
